@use "../../sass/global/global" as *;

:host {
    --ux-language-switch-shadow-height: 20px;
    --ux-language-switch-height-opened: 180px;

    display: inline-block;
    position: fixed;
    z-index: 1;
    box-sizing: border-box;
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease-in-out;
    padding: 0 15px;
}

:host * {
    box-sizing: inherit;
}

:host([opened]:not([opened="false"])) {
    height: calc(
        var(--ux-language-switch-height-opened) +
            var(--ux-language-switch-shadow-height)
    );
}

.panel {
    position: relative;
    background-color: #fff;
    box-shadow: 0 10px 14px 0 #00000026;
    height: 0;
    width: 170px;
    overflow: hidden;
    transition: height 0.3s ease-in-out;
}

.list {
    position: absolute;
    inset: 10px;
    display: flex;
    flex-direction: column;
    padding: 5px 0;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 3px;
    }
}

:host([opened]:not([opened="false"])) .panel {
    height: var(--ux-language-switch-height-opened);
}

.option {
    @include font(regular);
    text-transform: uppercase;
    background: transparent;
    border: 0;
    padding: 7px 10px;
    text-align: left;
    color: $color-scroll-bar;
    cursor: pointer;
}

.option:hover,
.option:focus {
    background-color: var(--ux-input-hover-bg);
    color: $color-black-1;
}

.option.is-selected {
    text-decoration: underline;
    color: $color-black-1;
}
